import { css, type Theme } from '@emotion/react';

export const container = (theme: Theme) => css`
  background: linear-gradient(to bottom, #deeef5, #f0fbff);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100%;
  width: 100%;

  @media (max-width: ${theme.breakpoints.tiny}) {
    padding: 0px 32px 32px 32px;
    gap: 32px;
  }
`;

export const body = (theme: Theme) => css`
  @media (min-width: ${theme.breakpoints.tiny}) {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  justify-content: center;
  z-index: 5;
`;

export const card = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  width: 351px;
  border-radius: 8px;
  border: none;
  gap: 32px;
  z-index: 2;

  @media (max-width: ${theme.breakpoints.tiny}) {
    width: 100%;
  }
`;

export const loginCardBody = css`
  display: flex;
  flex-direction: column;
  gap: 32px;
  justify-content: center;
  align-items: center;
`;

export const socialMedias = (theme: Theme) => css`
  margin: 0px auto;
  z-index: 10;

  @media (min-width: ${theme.breakpoints.tiny}) {
    display: none;
  }
`;
